<div class="course-cards">
    <div *ngFor="let course of courses" class="course-card">
        <div class="course-header">
          <div class="course-img">
            <img src="/assets/img/icons/course1.svg" alt="">
          </div>
          <div class="course-info">
            <div class="course-lessons">{{ course.lessonscount | lessonString:'урок':'урока':'уроков'}}</div>
            <div class="course-stars">
              <ng-container *ngFor='let key of course.stars | numberToArray'><i class="fas fa-star"></i></ng-container> 
              <ng-container *ngFor='let key of 5-course.stars | numberToArray'><i class="far fa-star"></i></ng-container>
            </div>
          </div>
        </div>
        <div class="course-body">
          <h3 class="course-name">{{course.name}}</h3>
          <p class="course-description">
            {{course.description}}
          </p>
        </div>
        <div class="course-link">
          
          <a *ngIf="course.started > 0; else start" class="button-purple-dark-fill" [routerLink]="['/courses', course.id]">Продолжить</a>
          <ng-template #start>
            <a class="button-purple-light-fill" [routerLink]="['/courses', course.id]">Начать курс</a>
          </ng-template>
          
        </div>
    </div>
    
  </div>